import money from 'v-money'
import { toUppercase } from './directives'
import filters from './filters'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

M.AutoInit()
window.Materialize = M

Dropzone.autoDiscover = false

window.Vue = require('vue')

import Vue from 'vue'

window.bus = new Vue()

bus.$on('reload-page', function () {
  location.reload()
})

// Provide an error handler to Vue.js. Any lifecycle errors that previously would have
// been caught and logged by Vue.js can be sent on to Bugsnag here. This error handler
// completely replaces the default behaviour, which means if you want to see the error
// in the console it'll need to be logged.
Vue.config.errorHandler = function (err, vm, info) {
  //console.error(err)
  if (Bugsnag == undefined) {
    console.log('BUGSNAG NAO CONFIGURADO')
    return
  }
  Bugsnag.notifyException(err, {
    vue: {
      errorInfo: info,
      component: vm ? vm.$options.name || vm.$options._componentTag ||
        'app root' : undefined,
      props: vm ? vm.$options.propsData : undefined,
    },
  })
}

function errorHandler (error) {
  let message = {
    html: 'Erro no servidor, entre em contato com o suporte.',
  }

  //Setup Error Message
  if (typeof error !== 'undefined') {
    if (error.hasOwnProperty('message')) {
      message.html = error.message
    }
  }

  if (typeof error.response !== 'undefined') {
    //Setup Generic Response Messages
    if (error.response.status === 401) {
      message.html = 'Sua sessão expirou!'
      Materialize.toast(message)

      setTimeout(() => {
        bus.$emit('reload-page')
      }, 3000)

    } else if (error.response.status === 403) {
      message.html = error.response.data.message
    } else if (error.response.status === 404) {
      message.html = 'Recurso não foi encontrado, entre em contato com o suporte'
    } else if (error.response.status === 422) {
      //Validation Message

      if (error.hasOwnProperty('response') &&
        error.response.hasOwnProperty('data')) {
        if (error.response.data.hasOwnProperty('errors')) {
          message.html = error.response.data.errors
        } else if (error.response.data.hasOwnProperty('message') &&
          error.response.data.message.length > 0) {
          message.html = error.response.data.message
        } else {
          message.html = error.response.data
        }
      }

    } else if (error.response.status === 429) {
      //o ideal é tratar no backend e enviar com outro código
      message.html = 'Limite de requisição atingido, entre em contato com o suporte'
    } else if (error.response.status >= 500) {
      message.html = 'Erro no servidor, entre em contato com o suporte.'
    }
  }

  if (typeof message.html === 'string') {
    if (message.html.length > 0) {
      Materialize.toast(message)
    }
  } else {
    bus.$emit('error-modal', message.html)
  }

  //Toast the Message

  return Promise.reject(error.response)
}

axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response
  },
  errorHandler,
)

/** Activate vue.js plugins **/
Vue.use(money, {
  precision: 2,
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  sufix: '',
  masked: true,
})

Vue.directive('touppercase', toUppercase)

Vue.mixin({
  filters: filters,
  methods: {
    ucwords: str => {
      str = str.toLowerCase()
      return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g,
        function ($1) {
          return $1.toUpperCase()
        })
    },
    buscarCep (endereco) {
      endereco.buscando = true

      axios.get('/ajax/consulta-cep', {
        params: {
          cep: endereco.cep,
        },
      }).then(function (response) {

        if (response.data.status == 'success' && response.data.address.erro !=
          true) {
          endereco.estado = response.data.address.uf
          endereco.cidade = response.data.address.localidade
          endereco.bairro = response.data.address.bairro
          endereco.endereco = response.data.address.logradouro
        }
        endereco.buscando = false

        setTimeout(function () {
          bus.$emit('updateFormCliente')
        }, 100)
      }).catch(function (thrown) {
        endereco.buscando = false
      })
    },
    usarLocalAtual (gps, endereco, event) {
      if (event) event.preventDefault()

      endereco.lat = gps.lat
      endereco.long = gps.long

      gps.endereco.forEach(function (el) {
        for (let type of el.types) {
          if (type === 'street_number') {
            // Difcil dizer o numero correto
            //endereco.numero = el.long_name;
            break
          } else if (type === 'route') {
            endereco.endereco = el.long_name
            break
          } else if (type === 'administrative_area_level_2') {
            endereco.cidade = el.long_name
            break
          } else if (type === 'administrative_area_level_1') {
            endereco.estado = el.short_name
            break
          } else if (type === 'postal_code') {
            endereco.cep = el.long_name
            break
          } else if (type === 'sublocality_level_1') {
            endereco.bairro = el.long_name
            break
          }
        }

      })
      //endereco.endereco= descricao
    },
  },
})

import Tooltip from 'vue-directive-tooltip'

Vue.use(Tooltip, {
  placement: 'top',
  class: 'tooltip-custom',
})

import VueSelect from 'vue-cool-select'

Vue.use(VueSelect, {
  theme: 'material-design', // or 'material-design'
})

import AclMixin from './plugins/acl.js'
//Vue.mixin(AclMixin);
Vue.use(AclMixin)
/**
 * Componentes globais
 */

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

Vue.component('Datetime', Datetime)

Vue.component('header-section',
  require('./components/common/HeaderSection.vue'))
Vue.component('information-card',
  require('./components/common/InformationCard.vue'))
Vue.component('side-menu', require('./components/common/SideMenu.vue'))
Vue.component('badge-consulta',
  require('./components/common/BadgeConsulta.vue'))
Vue.component('material-select',
  require('./components/utils/MaterialSelect.vue'))
Vue.component('auto-complete-select',
  require('./components/utils/AutoCompleteSelect.vue'))
Vue.component('mask-money', require('./components/utils/MaskMoney.vue'))
Vue.component('input-mask', require('./components/utils/InputMask.vue'))
Vue.component('input-mask-cpf-cnpj',
  require('./components/utils/InputMaskCpfCnpj.vue'))
Vue.component('dropfile-tus', require('./components/utils/DropFileTus.vue'))
Vue.component('file-upload-generic',
  require('./components/utils/FileUploadGeneric.vue'))
Vue.component('modal', require('./components/utils/Modal.vue'))
Vue.component('modal-sem-jq', require('./components/utils/ModalSemJq.vue'))
Vue.component('overlay-message',
  require('./components/utils/OverlayMessage.vue'))
Vue.component('error-modal', require('./components/utils/ErrorModal.vue'))
Vue.component('loader', require('./components/utils/InlineLoader.vue'))
Vue.component('progress-loading',
  require('./components/utils/ProgressLoading.vue'))
Vue.component('paginacao', require('./components/common/Paginacao.vue'))
Vue.component('simulacao-parcelas',
  require('./components/SimulacaoParcelas.vue'))
Vue.component('simulacao-parcelas-novo',
  require('./components/SimulacaoParcelasNovo.vue'))
Vue.component('select-status', require('./components/common/SelectStatus.vue'));

(function ($) {
  $(function () {

    let elems = document.querySelectorAll('.modal')
    M.Modal.init(elems)

    M.Tabs.init($('.tabs'), {})

    $('.modal').modal()

    // Funções para dar trigger no evento e mudar o v-model do vue
    $.fn.trigger2 = function (eventName) {
      return this.each(function () {
        let el = $(this).get(0)
        triggerNativeEvent(el, eventName)
      })
    }

    $('.sidenav').sidenav()

    $('select').formSelect()
    $('.tooltipped').tooltip()

    let drops = document.querySelectorAll('.dropdown-trigger')
    M.Dropdown.init(drops)

    $('.timepicker').each(function () {
      let el = $(this)
      el.pickatime({
        defaultTime: 'now', // Set default time
        fromNow: 0,       // set default time to * milliseconds from now (using with default = 'now')
        twelvehour: false, // Use AM/PM or 24-hour format
        donetext: 'OK', // text for done-button
        cleartext: 'Limpar', // text for clear-button
        canceltext: 'Cancelar', // Text for cancel-button
        autoclose: false, // automatic close timepicker
        /*ampmclickable: true, // make AM PM clickable*/
        aftershow: function () { }, //Function for after opening timepicker
        afterDone: function () {
          el.trigger2('input')
        },
      })
    })

    $('.datepicker').each(function () {
      let el = $(this)

      el.datepicker({
        // Formats
        format: 'dd/mm/yyyy',
        selectMonths: true, // Creates a dropdown to control month
        selectYears: 200, // Creates a dropdown of 15 years to control year,
        /*today: 'Hoje',*/
        i18n: {
          today: 'Hoje',
          cancel: 'Cancelar',
          clear: 'Limpar',
          done: 'Ok',
          months: [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'],
          monthsShort: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez'],
          weekdays: [
            'Domingo',
            'Segunda',
            'Terça',
            'Quarta',
            'Quinta',
            'Sexta',
            'Sábado'],
          weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          weekdaysAbbrev: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        },

        onClose: function () {
          el.trigger2('input')
        },
      })
    })

    $('.mask-cpf').mask('000.000.000-00')
    $('.mask-cnpj').mask('00.000.000/0000-00')
    $('.mask-date').mask('00/00/0000')
    $('.mask-cep').mask('00000-000')
    let options = {
      onKeyPress: function (cpf, ev, el, op) {
        let masks = ['000.000.000-000', '00.000.000/0000-00'],
          mask = (cpf.length > 14) ? masks[1] : masks[0]
        el.mask(mask, op)
      },
    }
    $('.mask-cpf-cnpj').mask('000.000.000-000', options)

    $('.collapsible').collapsible()

  }) // end of document ready
})(jQuery) // end of jQuery name space

window.tus = require('tus-js-client')


// WEBPACK FOOTER //
// ./resources/assets/js/app.js